<template>
  <div class="loginBox" @keyup.enter="handleLogin">
    <div class="baseForm">
      <i v-if="closable" class="el-icon-close loginBox-close" @click="handleClose"></i>
      <div class="loginBox-title">
        <p>在籍考生登录</p>
      </div>
      <div class="formDiv">
        <div class="input-wrapper">
          <div class="loginBox-input clearfix">
            <img src="../assets/login/home_icon18.png" class="input-icon">
            <input type="text" class="ipt" placeholder="请输入证件号" v-model="form.account" />
          </div>
        </div>
        <div class="input-wrapper">
          <div class="loginBox-input clearfix">
            <img src="../assets/login/home_icon19.png" class="input-icon">
            <input type="password" class="ipt" placeholder="请输入密码" v-model="form.password" />
          </div>
        </div>
        <div class="codeBox-wrapper">
          <div class="codeBox d-flex d-flex-middle d-flex-between">
            <div class="loginBox-input clearfix code-input mb0">
              <img src="../assets/login/home_icon19.png" class="input-icon">
              <input type="text" class="ipt" placeholder="请输入验证码" v-model="form.code" maxlength="4" />
            </div>
            <div class="code-image-wrapper">
              <img :src="verificationImageUrl" id="img_verifycode" @click="refYzm();"
                alt="点击刷新验证码" class="yzm">
            </div>
          </div>
        </div>
        <button class="loginbtn" @click="handleLogin">登录</button>
        <!-- <button class="registerBtn" @click="handleRegister">新考生报名</button> -->
        <div class="functionBox">
          <a href="javascript:void(0)" @click="handleForget" class="forget-password-link">
            <span class="question-icon">?</span>
            <span>忘记密码</span>
          </a>
        </div>
        <div class="mmtic">考生默认密码为Sczk+证件号后6位</div>
      </div>
    </div>
    <LoginChoose ref="loginChooseRef" @success="handleLoginChooseSuccess"></LoginChoose>
  </div>
</template>

<script>
import LoginChoose from "@/views/LoginChoose.vue";

export default {
  name: 'LoginBox',
  components: {
    LoginChoose
  },
  props: {
    closable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      verificationImageUrl: null,
      form: {
        account: null,
        password: null,
        code: null,
        userAgent: window.navigator.userAgent.toLowerCase(),
      },
    };
  },
  created() {
    this.form.account = process.env.VUE_APP_BASE_USER
    this.form.password = process.env.VUE_APP_BASE_PW
    this.refYzm()
  },
  methods: {
    // 图形验证码
    refYzm() {
      this.form.randomStr = new Date().getTime();
      this.$http.post('/student/pc/common/pictureCode').then(res => {
        this.verificationImageUrl = res
      })
    },
    handleLogin() {
      // 验证表单
      if (!this.form.account) {
        this.$message.error('证件号不能为空')
        return;
      }
      if (!this.form.password) {
        this.$message.error('密码不能为空')
        return;
      }
      if (!this.form.code) {
        this.$message.error('验证码不能为空')
        return;
      }
      
      // 调用登录接口
      const _this = this;
      _this.$http.post('/student/pc/loginBefore', this.form).then((res) => {
        if (res.length > 1) {
          // 多个用户，显示选择框
          this.$refs.loginChooseRef.open(res)
          return
        }
        // 单个用户，直接登录
        _this.handleLoginSuccess(res[0].certiNo, res[0].id)
      }).catch(err => {
        // 登录失败，刷新验证码
        this.refYzm()
        this.form.code = ''
      })
    },
    handleLoginSuccess(certiNo, id) {
      const params = {
        account: certiNo,
        registerInfoId: id,
      }
      const _this = this
      _this.$http.post('/student/pc/login', params).then((res) => {
        _this.$store.commit("SET_TOKEN", res.token);
        _this.$store.commit("SET_SCHOOLINFO", res);
        _this.$http.get('/student/pc/getStudentInfo').then((res) => {
          _this.$store.commit("LOGIN", res);
          // 触发登录成功事件
          _this.$emit('success')
        })
      })
    },
    handleLoginChooseSuccess() {
      // LoginChoose 登录成功后，触发 LoginBox 的 success 事件
      this.$emit('success')
    },
    handleForget() {
      this.$router.push({ path: "/forget" })
    },
    handleRegister() {
      this.$router.push({ path: "/bm" })
    },
    handleClose() {
      this.$emit('close')
    }
  },
};
</script>

<style lang="scss" scoped>
.loginBox {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  .baseForm {
    width: 360px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    z-index: 2;
    padding-top: 15px;

    .loginBox-close {
      position: absolute;
      right: 12px;
      top: 12px;
      font-size: 20px;
      color: #1687DE;
      cursor: pointer;
      line-height: 1;
      transition: color 0.3s;
      z-index: 1;

      &:hover {
        color: #4084FF;
      }
    }

    .loginBox-title {
      p {
          font-weight: bold;
          font-size: 18px;
          color: #000;
          margin-bottom: 0;
          text-align: center;
          line-height: 60px;
      }
    }

    .formDiv {
      box-sizing: border-box;
      padding: 0 30px 30px 30px;
      position: relative;
      .mmtic{
        width: 100%;
        text-align: center;
        color: red;
        margin-top: 20px;
        font-size: 14px;
      }
      .input-wrapper {
        margin-bottom: 20px;
      }
      .loginBox-input {
        width: 100%;
        height: 36px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 10px;
        display: flex;
        align-items: center;
        margin-bottom: 0 !important;

        .input-icon {
          width: auto;
          height: 16px;
          margin-right: 10px;
          flex-shrink: 0;
        }

        input {
          width: calc(100% - 30px);
          height: 100%;
          line-height: 48px;
          border: none;
          outline: none;
          background: transparent;
          font-size: 14px;
          color: #333;
          
          &::placeholder {
            color: #999;
          }
        }
      }
      .codeBox-wrapper {
        margin-bottom: 20px;
        
        .codeBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          
          .code-input {
            flex: 1;
            min-width: 0;
          }
          
          .code-image-wrapper {
            flex-shrink: 0;
            
            .yzm {
              height: 34px;
              width: auto;
              cursor: pointer;
              border-radius: 4px;
              border: 1px solid #E0E0E0;
              display: block;
              
              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
  }
  .loginbtn {
    background: linear-gradient(90deg, #4A90E2 0%, #357ABD 100%);
    border-radius: 4px;
    width: 100%;
    height: 36px;
    border: none;
    outline: none;
    cursor: pointer;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
    transition: opacity 0.3s;
    
    &:hover {
      opacity: 0.9;
    }
    
    &:active {
      opacity: 0.8;
    }
  }

  .registerBtn {
    background: #FF8F1F;
    border-radius: 4px;
    width: 100%;
    height: 36px;
    border: none;
    outline: none;
    cursor: pointer;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
    transition: opacity 0.3s;
    
    &:hover {
      opacity: 0.9;
    }
    
    &:active {
      opacity: 0.8;
    }
  }

  .functionBox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    
    .forget-password-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: #666;
      font-size: 12px;
      cursor: pointer;
      
      .question-icon {
        width: 16px;
        height: 16px;
        border: 1px solid #999;
        border-radius: 50%;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        margin-right: 6px;
        flex-shrink: 0;
      }
      
      span:last-child {
        color: #666;
      }
      
      &:hover {
        .question-icon {
          background: #D0D0D0;
        }
        span:last-child {
          color: #333;
        }
      }
    }
  }
}
</style>
